// extracted by mini-css-extract-plugin
export default {"updated":"styles_updated__C8nXW","policy":"styles_policy__lZxvO"};